<template>
  <div class="appointmentList-view">
    <div class="flex-a-b-c">
      <el-button
        class="v-primary"
        type="primary"
        @click="addGoods"
        >{{ $t('merchandise', 'publishGoods') }}</el-button
      >
      <div>
        <el-select v-model="value" :placeholder="$t('merchandise', 'pleaseSelect')" style="width: 240px">
          <el-option value="" :label="$t('merchandise', 'all')" class="cbcc">{{ $t('merchandise', 'all') }}</el-option>
          <el-option
            v-for="item in optionList"
            :key="item.productsTypeId"
            :label="item.productsTypeName"
            :value="item.productsTypeId"
          >
          </el-option>
        </el-select>
        <el-button
          class="v-primary ml10"
          type="primary"
          @click="queryAppointmentPage"
          >{{ $t('merchandise', 'query') }}</el-button
        >
      </div>
    </div>

    <commonTable
      :tableData="tableData"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
      :currentPage="currentPage"
      :loading="loading"
      :total="total"
    >
      <template v-slot:table>
        <el-table-column prop="productsId" width="100" align="center" :label="$t('merchandise', 'productId')" />
        <el-table-column
          prop="productsName"
          align="center"
          :label="$t('merchandise', 'productName')"
          show-overflow-tooltip
        />
        <el-table-column prop="productsTypeName" align="center" :label="$t('merchandise', 'category')" />
        <el-table-column prop="price" align="center" :label="$t('merchandise', 'price')" />
        <el-table-column prop="createTime" align="center" :label="$t('merchandise', 'publishTime')">
          <template slot-scope="scope"
            ><span>{{ setDataTimeSec(scope.row.createTime) }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" :label="$t('merchandise', 'operation')">
          <template slot-scope="scope">
            <span
              class="mr10 hover_pointer cblue"
              @click="editorGoods(scope.row.productsId)"
              >{{ $t('merchandise', 'edit') }}</span
            >
            <customPopconfirm
              :confirm-button-text="$t('common', 'confirm')"
              :cancel-button-text="$t('common', 'cancel')"
              @confirm="delGoodsInfo(scope.row.productsId)"
              icon="el-icon-info"
              icon-color="red"
              :title="$t('merchandise', 'confirmDeleteGoods')"
            >
              <el-button slot="reference" class="hover_pointer corange" style="color: #fd634e" type="text"
                >{{ $t('merchandise', 'delete') }}</el-button
              >
            </customPopconfirm>
          </template>
        </el-table-column>
        <el-table-column align="center" :label="$t('merchandise', 'sort')">
          <template slot-scope="scope">
            <span
              class="el-icon-upload2 mr10 hover_pointer"
              style="font-size: 20px"
              @click="goodsSort('up', scope.row.productsId)"
              :title="$t('merchandise', 'moveUp')"
            ></span>
            <span
              class="el-icon-download hover_pointer"
              style="font-size: 20px"
              @click="goodsSort('down', scope.row.productsId)"
              :title="$t('merchandise', 'moveDown')"
            ></span>
          </template>
        </el-table-column>
      </template>
    </commonTable>
  </div>
</template>

<script>
import commonTable from "@/components/common/commonTable";
import customPopconfirm from "@/components/common/customPopconfirm";
import {
  fetchAppointmentGoodsList,
  fetchProductsTypeList,
  alterAppointmentGoodsSort,
  delProducts
} from "@/api/companyManage.js";
import { getDataTimeSec } from "@/utils";
import i18nMixin from '@/mixins/i18nMixin';

export default {
  mixins: [i18nMixin],
  name: "appointmentList",
  components: {
    commonTable,
    customPopconfirm
  },
  props:{
    jurisdiction:{
        type: Boolean,
        default: false,
    },
  },
  data() {
    return {
      userInfo: this.$store.state.loginRoot.userInfo,
      value: "",
      tableData: [],
      optionList: "", //全部分类
      loading: "",
      total: 0, //总条数
      currentPage: 1, //当前页数
      queryDate: "",
      pageNum: 1,
      pageSize: 10,
    };
  },
  
  computed: {
    setDataTimeSec() {
      return (data) => getDataTimeSec(data);
    },
  },
  mounted() {
    this.getTableData();
    this.getTypeList();
    
    // 监听语言变化，强制更新组件
    this.$root.$on('language-changed', () => {
      this.$forceUpdate();
    });
  },
  beforeDestroy() {
    // 清理事件监听
    this.$root.$off('language-changed');
  },
  methods: {
    //请求预约商品列表数据
    getTableData() {
      this.loading = true;
      let data = {
        ignore: true,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        appointmentTime: this.queryDate,
        productsTypeId: this.value,
      };
      fetchAppointmentGoodsList(data)
        .then((res) => {
          this.loading = false;
          this.tableData = res.data.pageInfo.list || "";
          this.total = res.data.pageInfo.total;
          this.tableData.forEach((v) => {
            v.price = JSON.parse(v.price);
            console.log(typeof(v.price))
            if(typeof(v.price)=="object"){
              v.price = v.price[0] + '~' + v.price[1]
            }
            v.appointmentTime = `${getDataTimeSec(
              v.startTime
            )} - ${getDataTimeSec(v.endTime)}`;
          });
        })
        .catch((err) => {
          this.loading = false;
          this.tableData = [];
          console.log(err);
        });
    },
    //查询分类
    getTypeList() {
      fetchProductsTypeList({ ignore: true })
        .then((res) => {
          this.optionList = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //筛选查询符合条件数据
    queryAppointmentPage() {
      this.currentPage = 1;
      this.pageNum = 1;
      this.loading = true;
      this.getTableData();
    },
    //修改排序
    goodsSort(type, id) {
      if(this.userInfo.roleId || this.jurisdiction){
        let data = "";
        if (type == "up") {
          data = {
            productsId: id,
            type: 1,
          };
        } else {
          data = {
            productsId: id,
            type: 2,
          };
        }
        alterAppointmentGoodsSort(data)
        .then((res) => {
                  this.$message({
          type: "success",
          message: this.$t('merchandise', 'operationSuccess'),
        });
          this.loading = true;
          this.getTableData();
        })
        .catch((err) => {
          console.log(err);
        });
      }else{
        this.$message({
          type: "warning",
          message: this.$t('merchandise', 'noPermission'),
        });
        return
      }
    },
    editorGoods(id){
      if(this.userInfo.roleId || this.jurisdiction){
        this.$router.push(`/launchProducts?id=${id}`)
      }else{
        this.$message({
          type: "warning",
          message: this.$t('merchandise', 'noPermission'),
        });
        return
      }
    },
    addGoods(){
      if(this.userInfo.roleId || this.jurisdiction){
        this.$router.push(`/launchProducts`)
      }else{
        this.$message({
          type: "warning",
          message: this.$t('merchandise', 'noPermission'),
        });
        return
      }
      // if(!this.userInfo.roleId){
      //   this.$message({
      //     type: "warning",
      //     message: "无操作权限",
      //   });
      //   return
      // }
     
    },
    //当前页变更
    handleCurrentChange(num) {
      this.pageNum = num;
      this.loading = true;
      this.getTableData();
    },
    //当前页查询数据条数变更
    handleSizeChange(num) {
      this.pageSize = num;
      this.pageNum = 1;
      this.currentPage = 1;
      this.loading = true;
      this.getTableData();
    },
    async delGoodsInfo(id){
      // if(!this.userInfo.roleId){
      //   this.$message({
      //     type: "warning",
      //     message: "无操作权限",
      //   });
      //   return
      // }
      if(this.userInfo.roleId || this.jurisdiction){
        await delProducts({productsId:id});
        this.getTableData();
      }else{
        this.$message({
          type: "warning",
          message: this.$t('merchandise', 'noPermission'),
        });
        return
      }
      
    }
  },
};
</script>

<style lang="scss" scoped>
.appointmentList-view {
  background: #ffffff;
  padding: 24px;
}
</style>